// Rilevazione jank del main thread via PerformanceObserver(longtask).
// Un long task oltre `jankThresholdMs` (default 100 — le entry longtask hanno
// già floor 50ms) emette un verdetto `performance_issue` subtype `jank` con la
// route corrente templatizzata. longtask è di fatto Chromium-only: dove non è
// supportato l'integrazione è un no-op silenzioso.

import type { Client } from '../../client'
import { templatizePath } from '../../templatize'

interface LongTaskEntry {
  duration: number
}

interface LongTaskList {
  getEntries(): LongTaskEntry[]
}

/// Installa l'observer. Ritorna la funzione di disinstallazione.
export function installJankDetection(client: Client): () => void {
  const Observer = globalThis.PerformanceObserver as
    (typeof PerformanceObserver & { supportedEntryTypes?: string[] }) | undefined
  if (!Observer || !Observer.supportedEntryTypes?.includes('longtask')) {
    return () => {}
  }

  const observer = new Observer((list) => {
    for (const entry of (list as LongTaskList).getEntries()) {
      if (entry.duration <= client.options.jankThresholdMs) continue
      client.recordJank(entry.duration, currentRoute())
    }
  })

  try {
    observer.observe({ entryTypes: ['longtask'] })
  } catch {
    return () => {}
  }

  return () => observer.disconnect()
}

function currentRoute(): string {
  if (typeof location === 'undefined') return '<unknown>'
  return templatizePath(location.pathname)
}
